import React from "react";
import { Link, useLocation } from "react-router-dom";
import { usePermissions } from "../../../../utils/permissions";

const tabs = [
  {
    key: "convocatoria-plantillas",
    label: "Plantillas de Convocatoria",
    to: "/dashboard/plantillas/convocatoria-plantillas",
    permissionList: "convocatoria_plantillas.listar",
    permissionAccess: "convocatoria_plantillas.acceso",
  },
];

const getActiveKey = (pathname) => {
  if (pathname.includes("/plantillas/convocatoria-plantillas")) return "convocatoria-plantillas";
  return "convocatoria-plantillas";
};

export default function PlantillasTabs() {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const activeKey = getActiveKey(location.pathname);
  const visibles = tabs.filter(
    (tab) => hasPermission(tab.permissionAccess) || hasPermission(tab.permissionList)
  );

  if (!visibles.length) return null;

  return (
    <ul className="nav nav-tabs dashboard-tabs mb-3">
      {visibles.map((tab) => {
        const isActive = activeKey === tab.key;
        const canList = hasPermission(tab.permissionList);
        return (
          <li className="nav-item" key={tab.key}>
            {canList ? (
              <Link className={`nav-link ${isActive ? "active" : ""}`} to={tab.to}>
                {tab.label}
              </Link>
            ) : (
              <button
                type="button"
                className={`nav-link disabled ${isActive ? "active" : ""}`}
                aria-disabled="true"
                disabled
                title="Sin permiso para listar"
              >
                {tab.label}
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
